var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3User(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6621 9.11032C15.9974 9.11032 17.0806 8.02789 17.0806 6.69261C17.0806 5.35733 15.9974 4.2749 14.6621 4.2749",
    stroke: "#000229",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7739 11.7373C16.1727 11.7648 16.5691 11.8213 16.9595 11.9092C17.5018 12.0154 18.1542 12.2377 18.3864 12.7242C18.5346 13.0359 18.5346 13.3988 18.3864 13.7112C18.155 14.1978 17.5018 14.4193 16.9595 14.5308",
    stroke: "#000229",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24171 9.11032C3.90644 9.11032 2.82324 8.02789 2.82324 6.69261C2.82324 5.35733 3.90644 4.2749 5.24171 4.2749",
    stroke: "#000229",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12971 11.7373C3.73096 11.7648 3.3345 11.8213 2.94415 11.9092C2.40179 12.0154 1.74943 12.2377 1.51797 12.7242C1.36901 13.0359 1.36901 13.3988 1.51797 13.7112C1.74866 14.1978 2.40179 14.4193 2.94415 14.5308",
    stroke: "#000229",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94789 12.2583C12.6536 12.2583 14.9651 12.6677 14.9651 14.3063C14.9651 15.9441 12.6689 16.3688 9.94789 16.3688C7.24143 16.3688 4.93066 15.9593 4.93066 14.3208C4.93066 12.6823 7.22691 12.2583 9.94789 12.2583Z",
    stroke: "#000229",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94812 9.92093C8.16367 9.92093 6.73291 8.49016 6.73291 6.70495C6.73291 4.92051 8.16367 3.48975 9.94812 3.48975C11.7326 3.48975 13.1633 4.92051 13.1633 6.70495C13.1633 8.49016 11.7326 9.92093 9.94812 9.92093Z",
    stroke: "#000229",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3User);
export default __webpack_public_path__ + "static/media/3 User.51b2cd42e493823ce7c01d9e78643926.svg";
export { ForwardRef as ReactComponent };